import api from './api';

export async function findClientByHost(hostname) {
  const result = await api.get(`/white-label/${hostname}`);
    return result.data;
}